import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { updateUserSettings } from '../../../../../app/page/page-storage/user-settings/user-settings.actions';
import { IGoogleCalendarFormProps } from './types';
import { FormTextInput } from '../../inputs/TextInput';

export const GoogleCalendarForm: FunctionComponent<IGoogleCalendarFormProps> = ({ googleCalendarEmbedUrl }) => {
  const dispatch = useDispatch();

  const formProps = useForm();

  const onSubmit = (data: { googleCalendarEmbedUrl: string | null }) => {
    if (data.googleCalendarEmbedUrl?.trim().length === 0) {
      data.googleCalendarEmbedUrl = null;
    }

    dispatch(updateUserSettings(data));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="googleCalendarEmbedUrl-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as { googleCalendarEmbedUrl: string }))}
        method="post"
      >
        <div className="field-container">
          <FormTextInput
            id="googleCalendarEmbedUrl"
            name="googleCalendarEmbedUrl"
            type="text"
            defaultValue={googleCalendarEmbedUrl}
            label="Enter your Google email address, or the Google calendar embed URL"
            placeholder="your.username@yourdomain.com"
          />
        </div>
      </form>
    </FormProvider>
  );
};
